import ConfirmeInitPassword from './ConfirmeInitPassword';
export default ConfirmeInitPassword;
